module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/timeline-bullet-db794153457460f0f5f93bea5f8754ec.svg";